import { render, staticRenderFns } from "./LayoutProfile.vue?vue&type=template&id=e9e6b8b2"
import script from "./LayoutProfile.vue?vue&type=script&lang=js"
export * from "./LayoutProfile.vue?vue&type=script&lang=js"
import style0 from "./LayoutProfile.vue?vue&type=style&index=0&id=e9e6b8b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports